import { ChevronLeft, ChevronRight, Loader2 } from 'lucide-react';
import { AllTranscriptsProps } from '@/types';
import useTranslation from '@/hooks/useTranslation';

interface NavigationControlsProps {
  onPrev: () => void;
  onNext: () => void;
  isPrevDisabled?: boolean;
  isNextDisabled?: boolean;
  isPrevLoading?: boolean;
  isNextLoading?: boolean;
  className?: string;
  isLoading?: boolean;
  selectedTranscript?: AllTranscriptsProps | null;
  label?: string;
}

export default function NavigationControls({
  onPrev,
  onNext,
  isPrevDisabled = false,
  isNextDisabled = false,
  isPrevLoading = false,
  isNextLoading = false,
  className = '',
  isLoading = false,
  selectedTranscript,
  label,
}: NavigationControlsProps) {
  const { lang } = useTranslation();
  return (
    <div className={`flex items-center bg-white rounded-lg text-neutral-900 ${className}`}>
      <button
        disabled={isPrevDisabled}
        type="button"
        className={`flex items-center justify-center border border-neutral-200 rounded-l-lg disabled:opacity-30 disabled:cursor-not-allowed h-9 w-9 hover:bg-neutral-50 transition-colors ${
          isPrevLoading && 'pointer-events-none'
        }`}
        onClick={onPrev}
      >
        {isPrevLoading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <ChevronLeft className="h-4 w-4" />
        )}
      </button>

      <div className="flex items-center min-w-[120px] justify-center px-3 text-sm font-medium border-t border-b border-neutral-200 h-9 text-neutral-700">
        {isLoading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <div className="flex items-center gap-1.5">
            {label ? (
              <span>{label}</span>
            ) : (
              <>
                <span>{lang.get('msg.participant')} </span>
                <span>{selectedTranscript?.respondent_index}</span>
              </>
            )}
          </div>
        )}
      </div>

      <button
        disabled={isNextDisabled}
        type="button"
        className={`flex items-center justify-center border border-neutral-200 rounded-r-lg disabled:opacity-30 disabled:cursor-not-allowed h-9 w-9 hover:bg-neutral-50 transition-colors ${
          isNextLoading && 'pointer-events-none'
        }`}
        onClick={onNext}
      >
        {isNextLoading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <ChevronRight className="h-4 w-4" />
        )}
      </button>
    </div>
  );
}
